import { sendUpdateUserConfirmCorrect } from "@/models/socket/user.model";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";
import React, { useContext, useState } from "react";

const ConfirmCorrect: React.FC = () => {
  const { userShouldUpdateAccount, setUserShouldUpdateAccount } =
    useContext(AppContext);
  const [submitting, setSubmitting] = useState<boolean>(false);

  async function handleConfirmCorrect() {
    setSubmitting(true);
    const response = await sendUpdateUserConfirmCorrect();
    if (response.rStatus === "error") {
      setSubmitting(false);
      genericFailureToast(
        response.rData || "Failed to confirm. Please try again later."
      );
      return;
    }

    setSubmitting(false);
    genericSuccessToast("Confirmation successful");
    setUserShouldUpdateAccount(false);
  }
  return (
    userShouldUpdateAccount && (
      <Button
        className={`w-auto ${submitting ? "cursor-not-allowed opacity-50 duration-500" : ""}`}
        onClick={handleConfirmCorrect}
        disabled={submitting}
        size={"sm"}
      >
        Confirm Details
      </Button>
    )
  );
};

export default ConfirmCorrect;
